import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import { Box, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import ImageModal from './ImageModal';
import { GetVendorImages, UpdateRequestStatus } from 'API/VendorOnboarding/api';
import SnackBar from '../../General/SnackBar';
import { IoClose } from "react-icons/io5";
import { useEffect } from 'react';
import ConfirmationDialog from './ConfirmationDialog';


export default function VendorViewModal(props) {

    const [ActiveStep, setActiveStep] = useState(0)
    const [OpenImage, setOpenImage] = useState(false)
    const [Image, setImage] = useState(null)
    const [IsLoading, setIsLoading] = useState(false)
    const [Filetype, setFiletype] = useState(null)

    const [AlertMessage, setAlertMessage] = useState(null)
    const [AlertType, setAlertType] = useState("success")
    const [OpenAlert, setOpenAlert] = useState(false)

    const [VendorCode, setVendorCode] = useState(null)
    const [Remarks, setRemarks] = useState(null)

    const [OpenConfirmDialog, setOpenConfirmDialog] = useState(false)
    const [ActionType, setActionType] = useState(null)
    const[ImageIndex, setImageIndex] = useState(null)

    const[ImageUrl,setImageUrl]=useState(null)
    const[ImageName, setImageName] = useState(null)


    const handleVendorCodeChange = (e) => {
        console.log("change.........");

        if (/^[a-zA-Z0-9 ]*$/.test(e.target.value) && e.target.value.length < 100) {
            setVendorCode(e.target.value)
        }

    }

    const handleRemarksCodeChange = (e) => {
        console.log("change.........");

        if (/^[a-zA-Z0-9 ]*$/.test(e.target.value) && e.target.value.length < 100) {
            setRemarks(e.target.value)
        }

    }

    useEffect(() => {
        setVendorCode(null)
        setActiveStep(0)
    }, [props.open])


    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const GeneralForm = [
        { name: 'vendor_code', lable: 'Vendor Code', type: 'text', pattern: "^[a-zA-Z0-9]*$" ,disabled:true},
        { name: 'vendor_name', lable: 'Vendor Name', type: 'text', pattern: "^[a-zA-Z ]*$" },
        { name: 'company_name', lable: 'Company Name', type: 'text', pattern: "^[a-zA-Z ]*$" },
        { name: 'dob', lable: 'Dob', type: 'date' },
        { name: 'pan_card_no', lable: 'Pan Number', type: 'vertfy', pattern: "^[a-zA-Z0-9]*$" },
        { name: 'mobile_number', lable: 'Mobile Number', type: 'text', pattern: "^[0-9]*$" },
        { name: 'email_address', lable: 'Email Address', type: 'text', pattern: "^[a-zA-Z0-9@._]*$" },
        { name: 'mobile_number_2', lable: 'Alternate Number', type: 'text', pattern: "^[0-9]*$" },
        { name: 'address', lable: 'Address', type: 'text', pattern: "^[a-zA-Z0-9/. ]*$" },
        { name: 'pin_code', lable: 'Pincode', type: 'text', pattern: "^[0-9]*$" },
        { name: 'district', lable: 'District', type: 'text', pattern: "^[a-zA-Z ]*$", disabled: true },
        { name: 'sub_district', lable: 'Sub District', type: 'text', pattern: "^[a-zA-Z ]*$", disabled: true },
        { name: 'city_name', lable: 'City or Town', type: 'text', pattern: "^[a-zA-Z ]*$" },

    ]

    const AccountForm = [
        { name: 'gst_number', lable: 'GST Number', type: 'text', pattern: "^[0-9A-Z]*$" },
        { name: 'bank_name', lable: 'Bank Name', type: 'text', pattern: "^[a-zA-Z ]*$" },
        { name: 'ifsc_code', lable: 'IFSC Code', type: 'text', pattern: "^[a-zA-Z0-9]*$" },
        { name: 'bank_account_number', lable: 'Current Account Number', type: 'verify', pattern: "^[0-9]*$" },
        { name: 'bank_account_name', lable: 'Bank Account Name', type: 'text', pattern: "^[a-zA-Z ]*$", disabled: true },
    ]


    const handleImageModalClose = () => {
        setOpenImage(false)
    }

    const handleImageOpen = () => {
        setOpenImage(true)
    }


    const handleAlertOpen = (message, type) => {
        setAlertMessage(message)
        setAlertType(type)
        setOpenAlert(true)
    }

    const handleAlertClose = () => {
        setOpenAlert(false)
    }

    const handleViewFile = (url,index,name) => {
        GetVendorImages(url, setImage, handleImageOpen, handleAlertOpen, setFiletype, setIsLoading)
        setImageUrl(url)
        setImageIndex(index)
        setImageName(name)
    }

    const handleOpenConfirmDialog = (type) => {
        setOpenConfirmDialog(true)
        setActionType(type)
    }

    const handleCloseConfirmDialog = () => {
        setRemarks("")
        setOpenConfirmDialog(false)
        setVendorCode(null)
    }

    const handleSubmit = () => {
        if (Remarks || ActionType === "approved") {
            UpdateRequestStatus(VendorCode ? VendorCode : props.data['vendor_code'], ActionType, props.data._id, setIsLoading, handleAlertOpen)
        }
        else {
            handleAlertOpen("Please enter some remarks", "error")
        }


    }

    const handleLoading=()=>{
        setIsLoading(true)
    }

    const handleCloseLoading=()=>{
        setIsLoading(false)
    }




    return (
        <React.Fragment>
            <ConfirmationDialog open={OpenConfirmDialog} handleClose={handleCloseConfirmDialog} handleSubmit={handleSubmit} remarks={Remarks} handleChange={handleRemarksCodeChange} IsLoading={IsLoading} />
            <ImageModal imageName={ImageName} imageUrl={ImageUrl} fileType={Filetype} open={OpenImage} handleClose={handleImageModalClose} image={Image} IsLoading={IsLoading} handleAlertOpen={handleAlertOpen} handleLoading={handleLoading} handleCloseLoading={handleCloseLoading}/>
            <SnackBar open={OpenAlert} type={AlertType} message={AlertMessage} handleClose={handleAlertClose} />
            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="lg"
            >


                <DialogContent>
                    <Box sx={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer', fontSize: '25px' }} onClick={props.handleClose}>
                        <IoClose />
                    </Box>

                    {
                        ActiveStep === 0 ?
                            <>
                                <Typography variant='h4' mb={1}>Basic Details</Typography>
                                <Grid container spacing={2}>
                                    {

                                        props.data && GeneralForm.map((item, index) => (
                                            <Grid item key={index} xl={4} lg={4} md={12} xs={3}>
                                                <TextField
                                                    fullWidth
                                                    id="outlined-basic"
                                                    label={item.lable}
                                                    variant="outlined"
                                                    // onChange={(e) => item.name === "vendor_code" ? handleVendorCodeChange(e) : null}

                                                    inputProps={
                                                        {
                                                            contentEditable: false,
                                                            readOnly: true
                                                        }
                                                    }
                                                    value={item.name === "vendor_code" ? VendorCode || VendorCode === "" ? VendorCode : props.data[item.name] ? props.data[item.name] : "" : props.data[item.name] ? props.data[item.name] : ""}
                                                />
                                            </Grid>

                                        ))
                                    }
                                </Grid>

                                <Grid container spacing={2} mt={1}>
                                    {

                                        props.data && AccountForm.map((item, index) => (
                                            <Grid item key={index} xl={4} lg={4} md={12} xs={3}>
                                                <TextField
                                                    fullWidth
                                                    id="outlined-basic"
                                                    label={item.lable}
                                                    variant="outlined"
                                                    onChange={(e) => item.name === "vendor_code" ? handleVendorCodeChange(e) : null}
                                                    inputProps={
                                                        {
                                                            contentEditable: false
                                                        }
                                                    }
                                                    value={item.name === "vendor_code" ? VendorCode && VendorCode !== "" ? VendorCode : props.data[item.name] ? props.data[item.name] : "" : props.data[item.name] ? props.data[item.name] : ""}
                                                />
                                            </Grid>

                                        ))
                                    }
                                </Grid>
                            </>
                            :
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography variant='h4'>Documents</Typography>
                                    <table>
                                        <tr>
                                            <td><Typography variant='h5'>Pancard</Typography></td>
                                            <td><Button disabled={IsLoading} variant='contained' size='small' color='secondary' onClick={() => handleViewFile(props.data["uploaded_file"]["pan_card"],1,"pancard")}>{IsLoading&&ImageIndex===1?<CircularProgress size="22px" color="inherit"/>: "view"}</Button></td>
                                        </tr>
                                        <tr>
                                            <td><Typography variant='h5'>GST</Typography></td>
                                            <td><Button disabled={IsLoading} variant='contained' size='small' color='secondary' onClick={() => handleViewFile(props.data["uploaded_file"]["gst_no"],2,"gst")}>{IsLoading&&ImageIndex===2?<CircularProgress size="22px" color="inherit"/>: "view"}</Button></td>
                                        </tr>
                                        <tr>
                                            <td><Typography variant='h5'>Copy of Passbook/Cancelled cheque</Typography></td>
                                            <td><Button disabled={IsLoading} variant='contained' size='small' color='secondary' onClick={() => handleViewFile(props.data["uploaded_file"]["passbook/cancelled_cheque"],3,"passbook-cheque")}>{IsLoading&&ImageIndex===3?<CircularProgress size="22px" color="inherit"/>: "view"}</Button></td>
                                        </tr>
                                    </table>
                                </Grid>
                            </Grid>
                    }

                </DialogContent>
                {
                    ActiveStep === 0 ? (
                        <DialogActions>

                            <Grid container spacing={2} justifyContent="center">
                                <Grid item xs={2}>
                                    <Button fullWidth variant='contained' color='secondary' size='small' onClick={handleNext}>
                                        Next
                                    </Button>
                                </Grid>

                            </Grid>
                        </DialogActions>
                    )
                        :
                        (
                            <DialogActions>
                                <Grid container spacing={2} justifyContent="space-between" padding={3}>
                                    <Grid item xs={2}>
                                        <Button autoFocus={false} fullWidth variant='contained' size='small' color='secondary' onClick={handleBack}>
                                            Back
                                        </Button>
                                    </Grid>
                                    {
                                        props.type === "pending" ?
                                            <Grid item xs={4}>
                                                <Stack gap={1} direction="row">
                                                    <Button autoFocus={false} fullWidth variant='contained' size='small' color='success' onClick={() => handleOpenConfirmDialog("approved")}>
                                                        Approve
                                                    </Button>
                                                    <Button autoFocus={false} fullWidth variant='contained' size='small' color='error' onClick={() => handleOpenConfirmDialog("rejected")}>
                                                        Reject
                                                    </Button>
                                                </Stack>
                                            </Grid>
                                            :
                                            null
                                    }

                                </Grid>
                            </DialogActions>

                        )
                }

            </Dialog>
        </React.Fragment>
    );
}
